<script>
  import BackButton from './BackButton.svelte'
  import { createEventDispatcher } from 'svelte'
  import { currentLanguage } from '../../store'
  import translations from '../../translations'

  const dispatch = createEventDispatcher()
  export let showBookingForm
  export let firstName = ''

  let currentLang = navigator.language.split('-')[0] || 'en'

  currentLanguage.subscribe((value) => {
    currentLang = value
  })
</script>

<div class="chatwith-booking-info">
  {#if showBookingForm}
    <div class="chatwith-booking-back" on:click={() => dispatch('back')}>
      <BackButton />
    </div>
  {/if}
  {#if firstName}
    <div class="chatwith-booking-greeting">
      {translations.hello[currentLang] || translations.hello.en} {firstName}
    </div>
  {/if}
</div>
